import Icon from '../generic/Icon';
import { onElementBlur } from '../utils/onElementBlur';
import { trackHeaderLinkClick } from '../utils/trackLinkClick';
import useBooleanState from '../utils/useBooleanState';
import type { DropDownMenuProps } from './DropDownMenu';
import DropDownMenu from './DropDownMenu';
import * as style from './MegaMenu.module.css';

export default function MegaMenu({ links }: DropDownMenuProps) {
    const [isOpen, setIsOpen] = useBooleanState();

    return (
        <div className={style.hamburgerMenu} onBlur={onElementBlur(setIsOpen.toFalse)}>
            <button onClick={setIsOpen.toggle} aria-controls="mega-menu" aria-expanded={isOpen} aria-label={isOpen ? 'Steng menyen' : 'Åpne menyen'}>
                <span className={style.hamburgerMenuIcon} aria-hidden="true">
                    <span></span>
                    <span></span>
                    <span></span>
                    <span></span>
                </span>
            </button>
            <div className={style.megaMenu} id="mega-menu" onClick={trackHeaderLinkClick}>
                <div className="section__inner-container">
                    <div className={style.menuContainer}>
                        <a href="/finn-butikk" className={style.myStoreButton}>
                            <Icon className={style.iconMyStore} /> Butikker og åpningstider
                        </a>
                        <DropDownMenu links={links} />
                    </div>
                </div>
            </div>
        </div>
    );
}
